import { useAuth } from "@/contexts/AuthContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ChangePasswordForm } from "@/pages/ForcePasswordChange";
import { KeyRound, User } from "lucide-react";

export default function Profile() {
  const { user, logout } = useAuth();
  if (!user) return null;
  return (
    <div className="p-4 md:p-8 max-w-3xl mx-auto space-y-6" data-testid="profile-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-[#d63384] font-semibold">Il mio profilo</div>
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-[#0a0a2e]">Ciao, {user.full_name?.split(" ")[0] || user.email}</h1>
        <p className="text-slate-500">Gestisci le informazioni del tuo account.</p>
      </div>

      <Card className="ama-card border-0 shadow-none">
        <CardHeader><CardTitle className="font-heading text-lg flex items-center gap-2"><User className="w-4 h-4 text-[#d63384]" /> Dati account</CardTitle></CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-3 text-sm">
            <Field label="Nome completo" value={user.full_name} />
            <Field label="Email" value={user.email} />
            <Field label="Ruoli" value={user.roles?.map((r) => <Badge key={r} variant="outline" className="mr-1">{r}</Badge>)} />
            <Field label="Stato" value={user.active ? "Attivo" : "Disattivato"} />
          </div>
        </CardContent>
      </Card>

      <Card className="ama-card border-0 shadow-none" data-testid="profile-security-card">
        <CardHeader><CardTitle className="font-heading text-lg flex items-center gap-2"><KeyRound className="w-4 h-4 text-[#d63384]" /> Sicurezza — Cambia password</CardTitle></CardHeader>
        <CardContent>
          <p className="text-sm text-slate-500 mb-4">Dopo il cambio password verrai automaticamente disconnesso da tutte le sessioni. Sarà necessario effettuare nuovamente l'accesso.</p>
          <ChangePasswordForm onSuccess={() => setTimeout(() => logout(), 700)} />
        </CardContent>
      </Card>
    </div>
  );
}

function Field({ label, value }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">{label}</div>
      <div className="text-sm text-[#0a0a2e] font-medium">{value || "-"}</div>
    </div>
  );
}
